/**
 * Convert an amount to a price by dividing by 100 (since all prices are stored
 * on the backend as integers) and setting to two decimal places.
 */
export const toPrice = (amount) => (amount / 100.0).toFixed(2)

/**
 * Icon for Credit Card
 *
 * Takes a card brand (see supported brands in Stripe) and returns
 * a FontAwesome icon name if found.
 */
export const iconForCc = (brand) => {
  const brands = {
    'american express': 'cc-amex',
    'diners club': 'cc-diners-club',
    discover: 'cc-discover',
    jcb: 'cc-jcb',
    mastercard: 'cc-mastercard',
    visa: 'cc-visa',
  }

  return brands[brand.toLowerCase()]
}
